import { render } from "./SearchBoxSuggestions.vue?vue&type=template&id=6277bb56&scoped=true"
import script from "./SearchBoxSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchBoxSuggestions.vue?vue&type=script&lang=js"

import "./SearchBoxSuggestions.vue?vue&type=style&index=0&id=6277bb56&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6277bb56"]])

export default __exports__